'use client';

import { createContext, useContext } from 'react';

export type AttackPathPopoverLayer = 'flow' | 'page';

export const AttackPathPopoverLayerContext =
  createContext<AttackPathPopoverLayer>('flow');

export const useAttackPathPopoverLayer = (): AttackPathPopoverLayer =>
  useContext(AttackPathPopoverLayerContext);
